module.exports = __webpack_public_path__ + "static/media/CM.4982702b.svg";